import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DistributionChannelsComponent } from '@src/app/features/distribution-channels/distribution-channels/distribution-channels.component';
import { AddDistributionChannelComponent } from '@src/app/features/distribution-channels/add-distribution-channel/add-distribution-channel.component';
import { ViewDistributionChannelComponent } from '@app/features/distribution-channels/view-distribution-channel/view-distribution-channel.component';
import { EditDistributionChannelComponent } from '@src/app/features/distribution-channels/edit-distribution-channel/edit-distribution-channel.component';

const routes: Routes = [
  { path: '', component: DistributionChannelsComponent },
  { path: 'add', component: AddDistributionChannelComponent },
  { path: ':distributionChannelId/edit', component: EditDistributionChannelComponent },
  { path: ':distributionChannelId', component: ViewDistributionChannelComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DistributionChannelsRoutingModule { }
